import styles from '../css/Header.module.css';

export default function Header({
  // state, 
  // setState,
  t
}) {
  // const changeLang = (e, lang) => {
  //   i18n.changeLanguage(lang);
  // }

  return (
    <>
      <header className={styles.headerNormal}>
        <div className={styles.container}>
          <div className={styles.logoHolder}>
            <a className="elementor-icon" href="http://datakorea.io" style={{ height: "28px", marginLeft: "20px"}}>
              <img src="img/header_logo_black.svg" alt="logo"  />
            </a>
            {/* {
              !state.toggle &&
              <div className={styles.logotype}>
                <span>{t("title")}</span>
              </div> 
            } */}
          <div className={styles.logotype}>
                <span>{t("title")}</span>     
              </div> 
          </div>
          {/* <nav className={styles.menu}>
              <button type='reset' onClick={handleResetClick}>초기화</button>
              <button type='button' onClick={()=>setState({...state, menu:true})}>클러스터 변경</button>
              <button type='button'>상권분석</button>
              {

              }
              <button type='button'>구역선택</button>
              {
                
              }
              {
                currentLang?
                  <button type='button' className={styles.enBtn} onClick={(e) => langChangeBtn(e, 'kr')}>KR</button> :
                  <button type='button' className={styles.enBtn} onClick={(e) => langChangeBtn(e, 'en')}>EN</button>
              }
          </nav> */}
          {/* <div className={styles.mobileMenu}>
            <div className={styles.logotypeM}>{t("title")}</div>
            <div className={styles.menuM}>
            </div>
          </div> */}
        </div>
        {/* <nav role='navigation'>
          <div id={styles.menuToggle}>
            <input type="checkbox" />
            <span></span>
            <span></span>
            <span></span>
            
            <ul id={styles.menu}>
              <div>
                <a href="#"><li>{t("center")}</li></a>
                <a href="#"><li>{t("member")}</li></a>
                <a href="#"><li>{t("research")}</li></a>
                <a href="#"><li>{t("event")}</li></a>
              </div>
              <div id={styles.relativeSite}>
                <div className={styles.relativeTitle}>{t("site")}</div>
                <a href="#"><div>{t("information")}</div></a>
                <a href="#"><div>{t("datakorea")}</div></a>
                <a href="#"><div>{t("simulation")}</div></a>
              </div>
            </ul>
          </div>
        </nav> */}
      </header>
    </>
  )
}